export default {"src":"/_next/static/media/MicrosoftTeams.fab2b498.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};